(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal) return;

      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"] && !Shopify.designMode) return;
  try {
    

// Styling different color for heading
const heading = document.querySelector("#pcHeading");
if (heading) {
  const words = heading.textContent.trim().split(" ");
  const newHTML = words
    .map((word, index) => {
      if (index % 2 === 1) {
        return `<span class="pc_heading--alt">${word}</span>`;
      }
      return word;
    })
    .join(" ");

  heading.innerHTML = newHTML;
}

 
// Drawer toggle behavior (mobile/tablet)
(function(){
  const toggle = document.querySelector('.pc_drawer_toggle');
  const drawer = document.getElementById('pcDrawer');
  const overlay = drawer && drawer.querySelector('.pc_drawer_overlay');
  const panelContent = drawer && drawer.querySelector('.pc_drawer_content');
  const closeBtn = drawer && drawer.querySelector('.pc_drawer_close');
  const sourceList = document.querySelector('.pc_collection_lists');

  function openDrawer(){
    if(!drawer) return;
    if(panelContent && sourceList){
      panelContent.innerHTML = '';
      panelContent.appendChild(sourceList.cloneNode(true));
    }
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden','false');
    if(toggle) toggle.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(){
    if(!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden','true');
    if(toggle) toggle.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
    if(panelContent) panelContent.innerHTML = '';
  }
  if(toggle) toggle.addEventListener('click', openDrawer);
  if(closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if(overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closeDrawer();
  });
})();

// Auto-fit text for collection titles that overflow
(function(){
  function fitCollectionTitles() {
    const collectionItems = document.querySelectorAll('.pc_collection_list');
    
    collectionItems.forEach(function(item) {
      const titleSpan = item.querySelector('.pc_collection_title');
      if (!titleSpan) return;
      
      // Reset font size to original
      titleSpan.style.fontSize = '';
      
      // Get the available width (container width - icon - padding - gap)
      const itemStyles = window.getComputedStyle(item);
      const paddingLeft = parseFloat(itemStyles.paddingLeft);
      const paddingRight = parseFloat(itemStyles.paddingRight);
      const gap = parseFloat(itemStyles.gap) || 10;
      
      const icon = item.querySelector('.pc_collection_icon');
      const iconWidth = icon ? icon.offsetWidth : 0;
      
      const availableWidth = item.offsetWidth - paddingLeft - paddingRight - iconWidth - gap;
      
      // Check if text is overflowing
      if (titleSpan.scrollWidth > availableWidth) {
        // Calculate the ratio and reduce font size
        const currentFontSize = parseFloat(window.getComputedStyle(titleSpan).fontSize);
        const ratio = availableWidth / titleSpan.scrollWidth;
        let newFontSize = Math.floor(currentFontSize * ratio);
        
        // Set minimum font size to prevent text from becoming too small
        const minFontSize = 12;
        newFontSize = Math.max(newFontSize, minFontSize);
        
        titleSpan.style.fontSize = newFontSize + 'px';
      }
    });
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fitCollectionTitles);
  } else {
    fitCollectionTitles();
  }
  
  // Run on window resize
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(fitCollectionTitles, 100);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  // Initialize Slick Slider for Product Images
  document.addEventListener('DOMContentLoaded', function() {
    // Check if jQuery and Slick are available
    if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
      initProductSliders();
    } else {
      // Wait for slick to load
      var checkSlick = setInterval(function() {
        if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
          clearInterval(checkSlick);
          initProductSliders();
        }
      }, 100);
    }
    
    // Initialize variant selection
    initVariantSelection();
    
    // Initialize product tabs
    initProductTabs();
  });

  function initProductSliders() {
    var $ = jQuery;
    
    // Initialize main slider (dots disabled - we use custom dots)
    $('.mp-main-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      dots: false,
      infinite: true,
      adaptiveHeight: false
    });

    // Set first thumbnail as active
    $('.mp-thumb-slide').first().addClass('is-active');

    // When main slider changes, update active thumbnail and dots
    $('.mp-main-slider').on('afterChange', function(event, slick, currentSlide) {
      // Update thumbnails
      $('.mp-thumb-slide').removeClass('is-active');
      $('.mp-thumb-slide').eq(currentSlide).addClass('is-active');
      // Update custom dots
      $('.mp-dot').removeClass('is-active');
      $('.mp-dot').eq(currentSlide).addClass('is-active');
    });

    // When thumbnail is clicked, go to that slide
    $('.mp-thumb-slide').on('click', function() {
      var index = $(this).index();
      $('.mp-main-slider').slick('slickGoTo', index);
    });

    // When custom dot is clicked, go to that slide
    $('.mp-dot').on('click', function() {
      var index = $(this).data('slide');
      $('.mp-main-slider').slick('slickGoTo', index);
    });
  }

  function initVariantSelection() {
    // Get product variants data from the global scope
    var productVariants = window.mpProductVariants || [];
    var sectionId = window.mpProductSectionId;
    var container = sectionId ? document.querySelector('.section-wrapper-' + sectionId) : document;
    var dropdowns = container ? container.querySelectorAll('.mp-variant-dropdown') : document.querySelectorAll('.mp-variant-dropdown');
    
    // Helper to get current values of all dropdowns
    function getSelectedOptions() {
      var opts = [];
      dropdowns.forEach(function(d) {
        opts.push(d.value);
      });
      return opts;
    }

    // Function to update available options based on previous selections
    function updateAvailableOptions() {
      dropdowns.forEach(function(currentDropdown, currentIndex) {
        // Option 0 doesn't depend on previous options
        if (currentIndex === 0) return;
        
        // Get selected values of all previous options
        var previousOptions = [];
        for (var i = 0; i < currentIndex; i++) {
          previousOptions.push(dropdowns[i].value);
        }
        
        // Filter variants that match the constraints from previous options
        var validVariants = productVariants.filter(function(variant) {
          for (var j = 0; j < previousOptions.length; j++) {
            if (variant.options[j] != previousOptions[j]) {
              return false;
            }
          }
          return true;
        });
        
        // Collect valid values for the current option from the filtered variants
        var validValues = [];
        validVariants.forEach(function(variant) {
          var val = variant.options[currentIndex];
          if (validValues.indexOf(val) === -1) {
            validValues.push(val);
          }
        });
        
        // Update DOM options for the current dropdown
        var options = currentDropdown.querySelectorAll('option');
        var currentVal = currentDropdown.value;
        var foundCurrent = false;
        var firstValidVal = null;
        
        options.forEach(function(opt) {
          // Skip placeholder option
          if (opt.value === "") return;
          
          if (validValues.indexOf(opt.value) !== -1) {
            // Option is valid given previous selections
            opt.disabled = false;
            // Ensure option is visible
            opt.hidden = false;
            opt.style.display = '';
            
            if (opt.value === currentVal) foundCurrent = true;
            if (firstValidVal === null) firstValidVal = opt.value;
          } else {
            // Option is not compatible - disable but keep visible
            opt.disabled = true;
            // Ensure option is visible even if disabled
            opt.hidden = false;
            opt.style.display = '';
          }
        });
        
        // Auto-select the first valid option if current selection is invalid
        // This ensures the chain remains valid for subsequent options
        if (!foundCurrent && firstValidVal !== null) {
          currentDropdown.value = firstValidVal;
        }
      });
    }
    
    // Initial run to constrain options on page load
    updateAvailableOptions();
    
    // Initial price update
    updateVariantAndPrice(productVariants, getSelectedOptions(), true);
    
    // Handle dropdown change events
    dropdowns.forEach(function(dropdown) {
      dropdown.addEventListener('change', function() {
        // When a dropdown changes, update availability of downstream options
        updateAvailableOptions();
        
        // Then update the UI based on the new full selection
        updateVariantAndPrice(productVariants, getSelectedOptions(), true);
      });
    });
  }

  function updateVariantAndPrice(variants, selectedOptions, shouldScrollSlider) {
    // Find the variant that matches all selected options
    var matchingVariant = null;
    
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var matches = true;
      
      for (var j = 0; j < selectedOptions.length; j++) {
        if (variant.options[j] !== selectedOptions[j]) {
          matches = false;
          break;
        }
      }
      
      if (matches) {
        matchingVariant = variant;
        break;
      }
    }
    
    if (matchingVariant) {
      // Update the price display
      var priceElement = document.querySelector('.mp-product-price');
      if (priceElement) {
        var formattedPrice = formatMoney(matchingVariant.price);
        priceElement.textContent = 'Starting At ' + formattedPrice;
      }
      
      // Scroll to variant image if it has one and shouldScrollSlider is true
      if (shouldScrollSlider && matchingVariant.featured_image && matchingVariant.featured_image.src) {
        scrollToVariantImage(matchingVariant.featured_image.src);
      }
      
      // Update Enquire Now button href with selected variant
      var enquireBtn = document.getElementById('mp-enquire-btn');
      if (enquireBtn) {
        var baseUrl = enquireBtn.getAttribute('data-base-url');
        if (baseUrl) {
          var newUrl = baseUrl;
          if (matchingVariant.title) {
            newUrl += '&variant_title=' + encodeURIComponent(matchingVariant.title);
          }
          if (matchingVariant.sku) {
            newUrl += '&variant_sku=' + encodeURIComponent(matchingVariant.sku);
          }
          enquireBtn.href = newUrl;
        }
      }
    }
  }
  
  function scrollToVariantImage(imageSrc) {
    // Get the media src map from window
    var mediaSrcMap = window.mpMediaSrcMap || {};
    
    // Normalize the src by extracting the base path (remove query params and protocol)
    // The variant featured_image.src format is different from the media image_url format
    // So we need to find a match by comparing the core image filename
    var slideIndex = null;
    
    // Extract filename from the variant image src
    var variantFilename = extractImageFilename(imageSrc);
    
    // Search through the media map for a matching filename
    for (var mapSrc in mediaSrcMap) {
      var mapFilename = extractImageFilename(mapSrc);
      if (variantFilename && mapFilename && variantFilename === mapFilename) {
        slideIndex = mediaSrcMap[mapSrc];
        break;
      }
    }
    
    if (slideIndex !== null && typeof jQuery !== 'undefined') {
      var $ = jQuery;
      
      // Check if slick is initialized on the slider
      if ($('.mp-main-slider').hasClass('slick-initialized')) {
        $('.mp-main-slider').slick('slickGoTo', slideIndex);
      }
    }
  }
  
  function extractImageFilename(url) {
    if (!url) return null;
    // Remove query parameters and get the pathname
    try {
      // Get just the filename without any size suffixes or query params
      // Shopify URLs look like: //cdn.shopify.com/s/files/.../filename_800x.jpg?v=xxx
      var matches = url.match(/\/([^\/\?]+)(?:\?|$)/);
      if (matches && matches[1]) {
        // Remove size suffix like _800x or _800x800
        return matches[1].replace(/_\d+x\d*\./, '.').replace(/_\d+x\./, '.');
      }
    } catch (e) {
      console.log('Error parsing image URL:', e);
    }
    return null;
  }

  function initProductTabs() {
    var tabButtons = document.querySelectorAll('.mp-tab-btn');
    var tabPanels = document.querySelectorAll('.mp-tab-panel');
    
    tabButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var targetTab = this.getAttribute('data-tab');
        
        // Remove active state from all buttons
        tabButtons.forEach(function(btn) {
          btn.classList.remove('is-active');
        });
        
        // Remove active state from all panels
        tabPanels.forEach(function(panel) {
          panel.classList.remove('is-active');
        });
        
        // Add active state to clicked button
        this.classList.add('is-active');
        
        // Show corresponding panel
        var targetPanel = document.querySelector('.mp-tab-panel[data-panel="' + targetTab + '"]');
        if (targetPanel) {
          targetPanel.classList.add('is-active');
        }
      });
    });
  }

  function formatMoney(cents) {
    // Format cents to currency (assumes AUD or similar format)
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  } catch(e) { console.error(e); }
})();
})();
